// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B7aaP","rootNoMargin":"styles_rootNoMargin__34gDz"};